import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Logo } from 'foundations-components/transitional/components/Logo';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HsocV2PageHero() {
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: "1000",
    paddingInline: "800",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "400",
      children: [/*#__PURE__*/_jsx(Logo, {
        name: "hubspot-wordmark",
        width: "150px",
        alt: "HubSpot"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-800",
        textAlign: "center",
        marginBlock: "0",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hsocPricingPage.hero.headline"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-200",
        textAlign: "center",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hsocPricingPage.hero.subtitle"
        })
      })]
    })
  });
}